import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './image.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export const positions = ['none', 'left', 'right', 'center'];
export const sizes = ['default', 'full', 'flexible'];

export default class Image extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      src: { type: String },
      alt: { type: String },
      /**
       * How the image should flow
       * @type {'none'|'left'|'right'|'center'}
       */
      imagePosition: { type: String },
      /**
       * Intrinsic size or force 100% or flexible width.
       * @type {'default'|'full'|'flexible'}
       */
      imageSize: { type: String },
      /**
       * Pass a custom style to override the internal styles
       */
      styleOverride: { type: String },
    };
  }

  render() {
    const classes = classMap({
      image: true,
      [this.styleOverride]: !!this.styleOverride,
      [`image-style-align-${this.imagePosition}`]: !!this.imagePosition,
      [`image-style-size-${this.imageSize}`]: !!this.imageSize,
    });

    return html`<img src="${this.src}" alt="${this.alt}" class="${classes}" />`;
  }
}
customElements.define('hf-image', Image);
